import { createTheme } from "@mui/material/styles";
import { brand } from "./tokens";

const theme = createTheme({
  palette: {
    primary: { main: brand.primary },
    success: { main: brand.success },
    text: { primary: brand.text, secondary: brand.muted },
    background: { default: "#F8FAFC", paper: brand.white },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 600, lineHeight: 1.02 },
    h2: { fontWeight: 600, lineHeight: 1.1 },
    h3: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 12, padding: "12px 24px", fontSize: "1rem" },
        containedPrimary: {
          background: brand.primary,
          boxShadow: `0 8px 32px ${brand.primary}40`,
          "&:hover": {
            background: "#1A7AEF",
            transform: "translateY(-2px)",
            boxShadow: `0 12px 40px ${brand.primary}55`,
          },
        },
        outlined: {
          borderColor: "rgba(0,0,0,0.10)",
          "&:hover": { borderColor: `${brand.primary}66` },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          transition: "all 0.3s ease",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            backgroundColor: brand.mist,
            "& fieldset": { borderColor: "rgba(0,0,0,0.10)" },
            "&:hover fieldset": { borderColor: brand.primary },
            "&.Mui-focused fieldset": { borderColor: brand.primary },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 600, fontSize: "0.75rem" },
      },
    },
  },
});

export default theme;